// Registers the PWA service worker and keeps it up to date.
//
// The service worker caches the app shell. Without an explicit update check the
// installed PWA keeps serving stale code until the user deletes and reinstalls.
// This registers the SW and forces an update check on load and every time the
// app returns to the foreground, so a new deploy is picked up automatically.
// The SW's own skipWaiting()/clients.claim() then activate the new version and
// post SW_UPDATED, which PWAUpdateNotification surfaces as a "Refresh Now" prompt.

const SW_URL = '/pwabuilder-sw.js';

const isLocalhost = () =>
  ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return;
  // Skip during local development to avoid serving stale bundles while iterating.
  if (isLocalhost()) return;

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(SW_URL);

      // Check for a new service worker immediately on this load.
      registration.update();

      // ...and whenever the app is brought back to the foreground.
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update();
        }
      });
    } catch (error) {
      console.error('[SW] Registration failed:', error);
    }
  });
};
